<script>
import SearchInput from '@components/search-input/search-input.vue';
import SubheaderActions from '@components/subheader/subheader-actions.vue';
import { circuitModelMixin } from '@mixins/models/circuit-model-mixin';
import cloneDeep from 'lodash/cloneDeep';
import {
  circuitMethods,
  circuitComputed,
  adminPanelComputed,
  equipmentComputed,
  equipmentMethods,
  authComputed,
  organizationComputed,
  fitnessTypeComputed,
  fitnessTypeMethods,
} from '@state/helpers';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [circuitModelMixin, clickaway],
  props: {
    circuits: {
      type: Array,
      required: false,
      default: () => [],
    },
    inPanel: {
      type: Boolean,
      required: false,
    },
    createFromParent: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    SearchInput,
    SubheaderActions,
  },
  data() {
    return {
      createNewItem: false,
      newCircuitPlaceholder: null,
      isFocused: false,
      searchComponentKey: 0,
      toCircuit: null,
      toCircuitOwnerFilter: null,
      ownerFilters: this.inPanel ? ['all'] : ['sf'],
      equipmentType: [],
      searchOpts: { keys: ['label'] },
      initialCircuitList: null,
      clearEquipmentSelection: null,
    };
  },
  computed: {
    ...circuitComputed,
    ...adminPanelComputed,
    ...authComputed,
    ...equipmentComputed,
    ...organizationComputed,
    ...fitnessTypeComputed,
    selectedFilter() {
      return (
        this.ownerFilters &&
        this.ownerFilters.length > 0 &&
        this.ownerFilters[0]
      );
    },
    equipmentFilter() {
      if (
        this.circuits &&
        this.circuits.length > 0 &&
        this.isTrainer &&
        this.equipmentType &&
        this.equipmentType.length
      ) {
        const bodyWeightFilter = this.equipmentType.find(
          (type) => type._id === 'bodyWeight'
        );
        return this.circuits.filter((circuit) => {
          let matchingCircuit = null;
          if (circuit.exercises && circuit.exercises.length) {
            circuit.exercises.forEach((exercise) => {
              if (bodyWeightFilter && !exercise.requiredEquipment?.weighted) {
                matchingCircuit = circuit;
              }
              const equipments = this.requiredEquipment(exercise);
              const hasEquipment = equipments && equipments.length;
              if (hasEquipment) {
                const matchEquipment = this.equipmentType.every((type) =>
                  equipments.find((equipment) => type._id === equipment._id)
                );
                if (matchEquipment) {
                  matchingCircuit = circuit;
                }
              }
            });
          }
          if (matchingCircuit) {
            return matchingCircuit;
          }
        });
      } else {
        return this.circuits;
      }
    },
    ownerFilteredCircuits() {
      if (
        this.equipmentFilter &&
        this.equipmentFilter.length > 0 &&
        this.isTrainer
      ) {
        return this.equipmentFilter.filter((circuit) => {
          const filterName = this.ownerFilters[0];
          if (filterName === 'mine' && circuit.trainer_id === this.trainerId) {
            return circuit;
          }
          if (filterName === 'sf' && circuit.trainer_id === '0') {
            return circuit;
          }
          if (filterName === 'all') {
            return circuit;
          }
        });
      } else if (
        this.equipmentFilter &&
        this.equipmentFilter.length > 0 &&
        !this.isTrainer
      ) {
        return this.equipmentFilter;
      } else {
        return [];
      }
    },
    isInSplitPaneFull() {
      return (
        this.panelContent &&
        this.panelContent.data &&
        this.panelContent.data.componentRight &&
        !this.panelContent.data.componentRight.showPanelDetail
      );
    },
    isTrainer() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer
      );
    },
    allEquipmentSorted() {
      const allEquipmentSortedd = [
        { _id: 'bodyWeight', label: 'Bodyweight' },
        ...this.allEquipment,
      ];
      const sortedArray = this.sortAlphabeetically(allEquipmentSortedd);
      return sortedArray;
    },
  },
  async created() {
    if (!this.allEquipment || !this.allEquipment.length) {
      this.getAllEquipment({ orgId: this.userOrgId, trainerId: '0' });
    }
    if (!this.allFitnessTypes || !this.allFitnessTypes.length) {
      await this.getAllFitnessTypes({ orgId: this.userOrgId});
    }
    if (this.inPanel) {
      this.initialCircuitList = cloneDeep(this.circuits);
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (
        modalId === 'unsaved-changes-modal' &&
        !this.hasUnsavedCircuitChanges &&
        this.$route.name === 'circuits'
      ) {
        if (this.goToCircuit && this.toCircuitOwnerFilter) {
          // Auto selecting toCircuit when modal closed and circuit discard button clicked
          if (this.newCircuit.length) {
            this.toggleNewCircuitPlaceholder();
            this.newCircuitPlaceholder = null;
          }
          if (this.goToCircuit === 'new-circuit') {
            this.toggleNewCircuitPlaceholder();
            if (!this.newCircuit.length) {
              const newCircuitPlaceholder = {
                ...this.getCircuitModel(),
                label: '',
                newCircuit: true,
                selected: true,
              };
              this.toggleNewCircuitPlaceholder(newCircuitPlaceholder);
              this.setSelectedCircuit(newCircuitPlaceholder);
              this.$emit('set-init-circuit', newCircuitPlaceholder);
              this.createNewItem = true;
            }
          } else {
            this.$emit('set-init-circuit', this.goToCircuit);
            this.$emit('select-circuit-item', this.goToCircuit);
            this.setSelectedCircuit(null);
          }
          this.ownerFilters = [this.toCircuitOwnerFilter];
          this.toCircuitOwnerFilter = null;
          this.setGoToCircuit(null);
        } else if (this.goToCircuit) {
          // Auto selecting toCircuit when modal closed and circuit discard button clicked
          this.$emit('set-init-circuit', this.goToCircuit);
          this.$emit('select-circuit-item', this.goToCircuit);
          if (this.newCircuit.length) {
            this.toggleNewCircuitPlaceholder();
            this.newCircuitPlaceholder = null;
          }
          this.toCircuitOwnerFilter = null;
          this.setGoToCircuit(null);
        } else if (this.toCircuitOwnerFilter) {
          // Auto selecting ownerFilter when modal closed and circuit discard button clicked
          this.$emit('set-init-circuit', null);
          this.$emit('set-create-from-parent', false);
          this.setSelectedCircuit(null);
          if (this.newCircuit.length) {
            this.toggleNewCircuitPlaceholder();
            this.newCircuitPlaceholder = null;
          }
          this.ownerFilters = [this.toCircuitOwnerFilter];
          this.toCircuitOwnerFilter = null;
          this.setGoToCircuit(null);
        }
      } else {
        // keep changes then empty till the next circuit or filter select
        this.toCircuitOwnerFilter = null;
        this.setGoToCircuit(null);
      }
    });
    this.clearEquipmentSelection = document
      .getElementById('circuitEquipmentFilter')
      .getElementsByClassName('vs__dropdown-toggle')[0]
      .getElementsByClassName('vs__actions')[0]
      .getElementsByClassName('vs__clear')[0];
    this.clearEquipmentSelection.addEventListener(
      'click',
      this.deselectAllEquipment
    );
  },
  destroyed() {
    if (this.newCircuit.length) {
      this.toggleNewCircuitPlaceholder();
      this.newCircuitPlaceholder = null;
    }
    this.setAllCircuits(this.initAllCircuits);
    if (this.isFiltering) {
      this.toggleIsFiltering();
    }
  },
  methods: {
    ...circuitMethods,
    ...equipmentMethods,
    ...fitnessTypeMethods,
    showNewCircuitItem() {
      if (!this.createFromParent && this.hasUnsavedCircuitChanges) {
        // Show modal if changes available before allow selecting to another item
        this.$router.app.$bvModal.show('unsaved-changes-modal');
        this.setGoToCircuit('new-circuit');
        this.toCircuitOwnerFilter = 'mine';
      } else {
        this.ownerFilters = ['mine'];
        this.toggleNewCircuitPlaceholder();
        if (!this.newCircuit.length) {
          const newCircuitPlaceholder = {
            ...this.getCircuitModel(),
            label: '',
            newCircuit: true,
            selected: true,
          };
          this.toggleNewCircuitPlaceholder(newCircuitPlaceholder);
          this.setSelectedCircuit(newCircuitPlaceholder);
          this.$emit('set-init-circuit', newCircuitPlaceholder);
          this.createNewItem = true;
        }
      }
    },
    onFocus() {
      if (!this.isFiltering && !this.isFocused) {
        this.isFocused = true;
      }
    },
    onSelectCircuitItem(circuit) {
      if (this.hasUnsavedCircuitChanges) {
        // Show modal if changes available
        this.$router.app.$bvModal.show('unsaved-changes-modal');
        this.setGoToCircuit(circuit);
      } else {
        // Next
        this.$emit('set-init-circuit', circuit);
        this.$emit('select-circuit-item', circuit);
      }
    },
    onFilterResults(val) {
      if (this.newCircuit?.length) {
        this.toggleNewCircuitPlaceholder();
        this.newCircuitPlaceholder = null;
      }
      this.$emit('set-is-filtering', true);
      if (!this.isFiltering) {
        this.toggleIsFiltering();
      }
      if (!val) {
        if (this.isFiltering) {
          this.toggleIsFiltering();
        }
        this.$emit('set-is-filtering', false);
      }
      this.setSelectedCircuit(null);
      this.setAllCircuits(val);
    },

    visibilityChanged(isVisible, entry) {
      this.searchComponentKey++;
    },
    onSelectOwnerFilters(val) {
      if (this.hasUnsavedCircuitChanges) {
        // Show modal if changes available before selecting to a new owner filter
        this.$router.app.$bvModal.show('unsaved-changes-modal');
        this.toCircuitOwnerFilter = val;
      } else {
        this.$emit('set-init-circuit', null);
        this.$emit('set-create-from-parent', false);
        this.setSelectedCircuit(null);
        this.toggleNewCircuitPlaceholder();
        this.ownerFilters = [val];
      }
    },
    isSelectedEquipmentType(id) {
      // For the v-select check mark
      return this.equipmentType.find((equipment) => equipment._id === id);
    },
    onSelectEquipmentType(val) {
      // Handle v-select click event
      const index = this.equipmentType.findIndex(
        (item) => item._id === val._id
      );
      if (index === -1) {
        this.equipmentType.push(val);
      } else {
        // Remove if equipment selected
        this.equipmentType.splice(index, 1);
      }
    },
    deselectAllEquipment() {
      this.equipmentType.splice(0, this.equipmentType.length);
    },
    sortAlphabeetically(array) {
      // array of object that has a label property - used currently for equipments, could be abstracted later
      return array.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    },
    requiredEquipment(exercise) {
      // Helper to get all equipments in the one exercise
      const listOfEquipment = [];
      if (exercise && exercise.requiredEquipment) {
        if (exercise.requiredEquipment.weighted) {
          listOfEquipment.push(exercise.requiredEquipment.weighted);
        }
        if (
          exercise.requiredEquipment.unweighted &&
          exercise.requiredEquipment.unweighted.length
        ) {
          exercise.requiredEquipment.unweighted.forEach((equipment) => {
            listOfEquipment.push(equipment);
          });
        }
      }
      return listOfEquipment;
    },
  },
  watch: {
    createFromParent(val) {
      if (val) {
        this.showNewCircuitItem();
      }
    },
    isAdminPanelActive(val) {
      if (!val && this.inPanel) {
        this.visibilityChanged();
      }
    },
    isInSplitPaneFull(val) {
      if (!val && this.inPanel) {
        this.visibilityChanged();
      }
    },
    circuits(n, o) {
      // circuit prop isn't ready on created since parent hook is async, so watch it
      if (!this.inPanel && o.length === 0 && n.length > 0) {
        this.initialCircuitList = cloneDeep(n);
      }
    },
    equipmentType() {
      this.clearEquipmentSelection.style.display = this.equipmentType.length
        ? 'unset'
        : 'none';
    },
  },
};
</script>

<template>
  <div class="circuit-list">
    <div class="circuit-list-header" v-observe-visibility="visibilityChanged">
      <SubheaderActions>
        <SearchInput
          :key="searchComponentKey"
          :dark="true"
          :list="initialCircuitList"
          :options="searchOpts"
          @filter-results="onFilterResults"
          @focus-filter-input="onFocus"
        />
      </SubheaderActions>
    </div>
    <div class="library">
      <label>Library</label>
      <div v-if="isTrainer" :class="['filter-own-circuits', { inPanel }]">
        <span
          id="circuitAllOwnerButton"
          :class="{ selected: selectedFilter === 'all' }"
          @click="onSelectOwnerFilters('all')"
          >All Circuits</span
        >
        <span
          id="circuitSFOwnerButton"
          :class="{ selected: selectedFilter === 'sf' }"
          @click="onSelectOwnerFilters('sf')"
          >{{ organizationTitle }}</span
        >
        <span
          id="circuitMineOwnerButton"
          :class="{ selected: selectedFilter === 'mine' }"
          @click="onSelectOwnerFilters('mine')"
          >Custom Circuits</span
        >
      </div>
    </div>
    <div class="equipment">
      <label for="equipment">Equipment</label>
      <v-select
        id="circuitEquipmentFilter"
        multiple
        :class="'tdm-multi-select'"
        :closeOnSelect="false"
        :options="allEquipmentSorted"
        :searchable="false"
        :clearable="false"
        :value="equipmentType"
      >
        <template v-slot:selected-option-container="{ option }">
          <span>
            <span
              class="options-selected"
              v-if="equipmentType.indexOf(option) <= 2"
            >
              <span
                v-if="
                  equipmentType.indexOf(option) === 1 ||
                    equipmentType.indexOf(option) === 2
                "
                >,
              </span>
              {{ option.label }}
            </span>
            <span
              class="extra-options"
              v-if="
                equipmentType.indexOf(option) === 2 && equipmentType.length > 3
              "
            >
              and {{ equipmentType.length - 3 }} others</span
            >
          </span>
        </template>
        <template v-slot:option="{ _id, label }">
          <div
            class="option-label-wrapper"
            @click="onSelectEquipmentType({ _id, label })"
          >
            <div>{{ label }}</div>
            <BaseIcon
              class="icon-check"
              name="check"
              v-if="isSelectedEquipmentType(_id)"
            />
          </div>
        </template>
      </v-select>
    </div>
    <BaseListMinimal
      v-if="createNewItem && !inPanel"
      :items="newCircuit"
      :showIcon="true"
      @select-minimal-list-item="onSelectCircuitItem"
    />
    <BaseListMinimal
      v-if="circuits && circuits.length"
      :items="ownerFilteredCircuits"
      :showIcon="true"
      @select-minimal-list-item="onSelectCircuitItem"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity

.circuit-list {
  background-color: white;
  border-right: 1px solid $color-medium-gray;
  overflow-y: scroll;
  width: 52rem;

  .circuit-list-header {
    padding: 3rem 2rem;

    .subheader-actions-wrapper {
      margin-bottom: 0;

      .search-input-wrapper {
        padding-left: 0;
        width: 100%;
      }
    }
  }
  .library {
    margin: 0 2rem;
    label {
      color: $color-dark-gray-one;
      font-family: $base-font-family;
      font-size: 12px;
      font-style: normal;
      font-weight: 800;
      letter-spacing: 0.1px;
      line-height: 22px;
      text-transform: uppercase;
    }
    .filter-own-circuits {
      align-items: center;
      background: $color-off-white;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      margin-bottom: 2rem;
      padding: 0.75em;
      width: 100%;
      span {
        color: $color-black-one;
        cursor: pointer;
        font-family: $base-font-family;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.11px;
        line-height: 22px;
        padding: 0.5em;
        text-align: center;
        white-space: nowrap;
        @include calc-font-size(0.85);
        &:hover {
          background: rgba($color-black-wo-rgb, 0.1);
          border-radius: 4px;
          font-weight: 800;
        }
        &.selected {
          background: $color-action;
          border-radius: 4px;
          color: $color-white;
          font-weight: 800;
        }
      }
      &.inPanel {
        span {
          font-size: 1.4rem;
          margin-left: 0;
        }
      }
      span + span {
        margin-left: 1em;
      }
    }
  }
  .equipment {
    margin: 0 2rem;

    .options-selected {
      color: $color-dark-gray-one;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 21px;
    }
    .extra-options {
      color: $color-dark-gray-one;
      font-size: 14px;
      font-style: italic;
      font-weight: 300;
      letter-spacing: 0.116667px;
      line-height: 21px;
    }
  }
}
</style>
